//include 6
jQuery(function(){
    /*
	$('button.star').click(function(e){
		$(this).children('i').toggleClass('icon-star-full');
	});
    */
});